import React, { lazy } from "react";

/// React router dom
import { Switch, Route } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";
/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
import Main from "./layouts/Main";
/// Auth initialization
import AuthInit from "./AuthInit";
/// Plugins
/// paginas 
const Marcacion = lazy(() => import("./pages/Marcacion"));
const Usuarios = lazy(() => import("./pages/Usuarios"));
const Liquidaciones = lazy(() => import("./pages/Liquidaciones"));
const Clientes = lazy(() => import("./pages/Clientes"));
const FichaUser = lazy(() => import("./pages/Fichausuario"));
const FichaCliente = lazy(() => import("./pages/Fichaclientes.js"));
const Sesiones = lazy(() => import("./pages/Sesiones.js"));
const Cierre = lazy(() => import("./pages/liquidacion/Cierre.js"));
const OrdenDePago = lazy(() => import("./pages/Ordendepago.js"));
const SortingTable = lazy(() => import("./components/table/SortingTable/SortingTable"));
const FilteringTable = lazy(() => import("./components/table/FilteringTable/FilteringTable"));
const BootstrapTable = lazy(() => import("./components/table/BootstrapTable"));
const Login = lazy(() => import("./pages/Login"));
const Error400 = lazy(() => import("./pages/Error400"));
const Error403 = lazy(() => import("./pages/Error403"));
const Error404 = lazy(() => import("./pages/Error404"));
const Error500 = lazy(() => import("./pages/Error500"));
const Error503 = lazy(() => import("./pages/Error503"));
const Termino = lazy(() => import("./pages/Terminos.js"));
const FichaLiquidacion = lazy(() => import("./pages/liquidacion/Fichaliquidacion.js"));
const FichaLegajo = lazy(() => import("./pages/sesiones/FichaLegajo.js"));
const FichaOrden = lazy(() => import("./pages/ordendepago/FichaOrden.js"));
const Opciones = lazy(() => import("./pages/Opciones.js"));
const Admin = lazy(() => import("./pages/admin/admin.js"));
const Pagos = lazy(() => import("./pages/pagos/pagos.js"));
const Alquileres = lazy(() => import("./pages/alquileres/alquileres.js"));
const Appclientes = lazy(() => import("./pages/appclientes/appclientes.js"));
const Inventario = lazy(() => import("./pages/inventario/Inventario.js"));
const Markup = () => {
  const routes = [
    { url: "marcacion", component: Marcacion },
    { url: "usuarios", component: Usuarios },
    { url: "liquidaciones", component: Liquidaciones },
    { url: "legajo/:id", component: FichaLegajo },
    { url: "clientes", component: Clientes },
    { url: "Fichausuario/:id", component: FichaUser },
    { url: "Fichaclientes/:id", component: FichaCliente },
    { url: "Fichaorden/:id", component: FichaOrden },
    { url: "sesiones", component: Sesiones },
    { url: "cierre", component: Cierre },
    { url: "ordendepago", component: OrdenDePago }, // Added route
    { url: "fichaliquidacion/:id", component: FichaLiquidacion },
    { url: "opciones", component: Opciones },
    { url: "admin", component: Admin },
    { url: "datatable-filtering", component: FilteringTable },
    { url: "datatable-sorting", component: SortingTable },
    { url: "table-bootstrap-basic", component: BootstrapTable },
    { url: "pagos", component: Pagos },
    { url: "alquileres", component: Alquileres },
    { url: "appclientes", component: Appclientes },
    { url: "inventario", component: Inventario },
  ];

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  let pagePath = path.split("-").includes("page");

  return (
    <>
      <AuthInit />
      <Switch>
        {/* without layouts (nav, header, sidebar and footer) */}
        <Route path="/login" component={Login} />
        <Route path="/page-error-400" component={Error400} />
        <Route path="/page-error-403" component={Error403} />
        <Route path="/page-error-404" component={Error404} />
        <Route path="/page-error-500" component={Error500} />
        <Route path="/page-error-503" component={Error503} />
        <Route path="/Termino" component={Termino} />

        <Route path="/" exact>
          {/* You can add a default component here if needed */}
        </Route>
        <Route>
          <div id="main-wrapper" className="show">
            <Main>
              <Nav />
              <div className="layout-wrapper">
                <div className="content-body">
                  <div className="container-fluid">
                    <Switch>
                      {routes.map((data, i) => (
                        <Route
                          key={i}
                          exact
                          path={`/${data.url}`}
                          component={data.component}
                        />
                      ))}
                    </Switch>
                  </div>
                </div>
                <Footer />
              </div>
            </Main>
          </div>
        </Route>
      </Switch>
      <ScrollToTop />
    </>
  );
};

export default Markup;
